module.exports = __webpack_public_path__ + "static/conference-9f4b0d720527c12d158efd38f190ee75.png";